<template>
  <div class="cp-result">
    <h1 class="text-uppercase text-center mb-2">Kết quả đánh giá</h1>

    <CheckPointCategory title="Trao đổi trực tiếp" id="live">
      <div class="contents">
        <template v-for="(item, key) of critOpinion">
          <div class="contents__item" :key="key">
            <b>{{ key + 1 }}. {{ item.criteria_name }}</b>
            <div v-if="item.criteria_id === 1001">
             {{ item.dm_point_text }}
            </div>
            <div v-if="item.criteria_id === 1003">
             {{ item.coo_point_text }}
            </div>
            <div v-if="item.criteria_id === 1002">
             {{ item.hri_point_text }}
            </div>
            <div v-if="item.criteria_id === 1004">
             {{ item.dm_point_text }}
            </div>
          </div>
        </template>
      </div>
    </CheckPointCategory>

    <CheckPointCategory title="I. Đánh giá tinh thần , trách nhiệm và nội quy chung" id="attitude">
      <table class="table  table-bordered">
        <thead>
          <tr class="text-dark">
            <th rowspan="2">STT</th>
            <th rowspan="2">Nội dung</th>
            <th colspan="2">Tự đánh giá</th>
            <th colspan="2">
              Trưởng BP Đánh giá <br />
              <span>{{ memberInfo.dm_name }}</span>
            </th>
          </tr>
          <tr>
            <th>Điểm cá nhân</th>
            <th class="suggest">Ý KIẾN CÁ NHÂN</th>
            <th>Trưởng BP chấm</th>
            <th class="suggest">Trưởng BP Nhận xét</th>
          </tr>
        </thead>

        <tbody class="bg-white text-dark">
          <template v-for="(item, key) of critAttitude">
            <tr v-if="key === 0" :key="key">
              <td class="font-weight-bold index">{{ key + 1 }}</td>
              <td>
                <div class="_content d-flex justify-content-between align-items-center">
                  <span class="text-left">{{ item.criteria_name }}</span>
                  <CheckPointToolTip :toolText="strToolTip(item.criteria_tooltip)" />
                </div>
              </td>
              <td class="point">{{ item.member_point_text }}</td>
              <td class="suggest" :rowspan="critAttitude.length - 1">
                <div class="td-scroll">
                  {{ opinions.member_point_text }}
                </div>
              </td>
              <td class="point">{{ item.dm_point_text }}</td>
              <td class="suggest" :rowspan="critAttitude.length - 1">
                <div class="td-scroll">
                  {{ opinions.dm_point_text }}
                </div>
              </td>
            </tr>
          </template>
          <template v-for="(item, key) of critAttitude">
            <tr v-if="key > 0 && key < critAttitude.length - 1" :key="key + item.criteria_name + 'work'">
              <td class="font-weight-bold index">{{ key + 1 }}</td>
              <td>
                 <div class="_content d-flex justify-content-between align-items-center">
                  <span class="text-left">{{ item.criteria_name }}</span>
                  <CheckPointToolTip :toolText="strToolTip(item.criteria_tooltip)" />
                </div>
              </td>
              <td class="point">{{ item.member_point_text }}</td>
              <td class="point">{{ item.dm_point_text }}</td>
            </tr>
          </template>
        </tbody>
      </table>
    </CheckPointCategory>

    <CheckPointCategory title="II. ĐÁNH GIÁ hiệu quả CÔNG VIỆC " id="work">
      <div class="work__content">
        <table class="table table-bordered">
          <thead>
            <tr class="text-dark">
              <th rowspan="2">Tên dự án</th>
              <th rowspan="2">Thời gian <br> tham gia</th>
              <th rowspan="2">Vị trí</th>
              <th colspan="2">Tiêu chí đánh giá</th>
              <th colspan="2">Tự đánh giá</th>
              <th colspan="2">
                Quản lý trực tiếp đánh giá
               </th>
            </tr>

            <tr>
              <th>STT</th>
              <th>Nội dung</th>
              <th>Điểm cá nhân</th>
              <th>Ý KIẾN CÁ NHÂN</th>
              <th>QLTT chấm</th>
              <th>Ý kiến của QLTT</th>
            </tr>
          </thead>

          <tbody class="bg-white text-dark">
            <template v-for="(project, key) of convertCritWork">
              <tr :key="key + project.id">
                <td class="name" :rowspan="project.crits.length - 1">
                   <p class="font-weight-bold mb-0">{{ project.name }}</p>
                   <p class="mb-0">QLTT: {{ project.pm_name }}</p>
                </td>
                <td :rowspan="project.crits.length - 1" class="text-center time">
                  {{ project.start_date }} <br />
                  ~ <br />
                  {{ project.end_date }}
                </td>
                <td class="text-center position" :rowspan="project.crits.length - 1">
                  {{ project.member_type }}
                </td>
                <td class="point">1</td>
                <td>
                  <div class="_content d-flex justify-content-between align-items-center">
                    <span class="text-left">{{ project.crits[0].criteria_name }}</span>
                    <CheckPointToolTip :toolText="strToolTip(project.crits[0].criteria_tooltip)" />
                  </div>
                </td>
                <td class="text-center point">
                  {{ project.crits[0].member_point_text }}
                </td>
                <td class="_opinion suggest" :rowspan="project.crits.length - 1">
                  <div class="td-scroll">
                    {{ project.crits[project.crits.length - 1].member_point_text }}
                  </div>
                </td>
                <td class="point">{{project.crits[0].pm_point_text}}</td>
                <td class="_opinion suggest" :rowspan="project.crits.length - 1">
                  <div class="td-scroll">
                    {{ project.crits[project.crits.length - 1].pm_point_text }}
                  </div>
                </td>
              </tr>
              <template v-for="(item, index) of project.crits">
                <tr
                 v-if="index > 0 && index < project.crits.length - 1"
                  :key="index + item.criteria_name + project.id"
                >
                  <td class="_index">{{ index + 1 }}</td>
                  <td>
                    <div class="_content d-flex justify-content-between align-items-center">
                      <span class="text-left">{{ item.criteria_name }}</span>
                      <CheckPointToolTip :toolText="strToolTip( item.criteria_tooltip)" />
                    </div>
                  </td>
                  <td class="text-center">{{ item.member_point_text }}</td>
                  <td class="point">{{item.pm_point_text}}</td>
                </tr>
              </template>
            </template>
          </tbody>
        </table>
      </div>
    </CheckPointCategory>

    <CheckPointCategory title="III. Đánh giá năng lực tổng quan" id="personal">
      <div class="personal__content">
        <table class="table table-bordered ">
          <thead>
            <tr class="text-dark">
              <th rowspan="2" style="width: 5%">STT</th>
              <th rowspan="2">Nội dung</th>
              <th colspan="2">Tự đánh giá</th>
              <th colspan="2">
                Trưởng BP Đánh giá <br />
                <span>{{uniqueCritPersonal[0] ? uniqueCritPersonal[0].dm_name:''}}</span>
              </th>
            </tr>
            <tr>
              <th>Điểm cá nhân</th>
              <th>Ý KIẾN CÁ NHÂN</th>
              <th>Trưởng BP chấm</th>
              <th>Trưởng BP Nhận xét</th>
            </tr>
          </thead>

          <tbody class="bg-white text-dark">
            <template v-for="(item, key) of uniqueCritPersonal">
              <tr v-if="key === 0 && key < uniqueCritPersonal.length - 1" :key="key">
                <td class="font-weight-bold">{{ key + 1 }}</td>
                <td>
                  <div class="_content d-flex justify-content-between align-items-center">
                    <span class="text-left">{{ item.criteria_name }}</span>
                    <CheckPointToolTip :toolText="strToolTip( item.criteria_tooltip)" />
                  </div>
                </td>
                <td class="point">{{ item.member_point_text }}</td>
                <td :rowspan="uniqueCritPersonal.length" class="_opinion suggest">
                  <div class="td-scroll">
                    {{
                      uniqueCritPersonal[uniqueCritPersonal.length - 1]
                        .member_point_text
                    }}
                  </div>
                </td>
                <td class="point">{{ item.dm_point_text }}</td>
                <td :rowspan="uniqueCritPersonal.length" class="_opinion suggest">
                  <div class="td-scroll">
                    {{
                      uniqueCritPersonal[uniqueCritPersonal.length - 1]
                        .dm_point_text
                    }}
                  </div>
                </td>
              </tr>
            </template>
            <template v-for="(item, key2) of uniqueCritPersonal">
              <tr v-if="key2 < uniqueCritPersonal.length - 1 && key2 > 0" :key="key2 + 1">
                <td class="font-weight-bold">{{ key2 + 1 }}</td>
                <td>
                  <div class="_content d-flex justify-content-between align-items-center">
                    <span class="text-left">{{ item.criteria_name }}</span>
                    <CheckPointToolTip :toolText="strToolTip( item.criteria_tooltip)" />
                  </div>
                </td>
                <td class="point">{{ item.member_point_text }}</td>
                <td class="point">{{ item.dm_point_text }}</td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </CheckPointCategory>

    <CheckPointCategory title="IV. Ý KIẾN CHUNG" id="pm_opinion">
      <table class="table table-bordered ">
        <thead>
          <tr class="text-dark">
            <th rowspan="2">STT</th>
            <th rowspan="2">Nội dung</th>
            <th rowspan="2">Ý kiến chung cá nhân</th>
            <template v-for="(comment, key) of getCommentUnique(critSuggest)">
                <th :key="key + comment.project_id">
                  ý kiến chung của qltt <br />
                  <span>{{ comment.pm_name }}</span>
                </th>
              </template>
            <th>
                Ý kiến chung của TRƯỞNG bp <br />
                <span>{{
                  uniqueCritOpinion.length > 0
                    ? uniqueCritOpinion[0].dm_name
                    : ""
                }}</span>
              </th>
          </tr>
        </thead>

        <tbody class="bg-white text-dark">
          <tr v-for="(suggest, key) of critSuggestAfter" :key="key">
              <td class="font-weight-bold index">{{ key + 1 }}</td>
              <td class="text-left">
                {{ suggest.criteria_name }}
              </td>
              <td class="suggest" :class="key === 5 ? 'text-left':''">
                <div class="td-scroll" v-if="key === 5">
                  <div v-if="suggest.comments[0].member_point_text_note">
                    {{ key === 5 && suggest.member_point_text === "Khác" ? suggest.member_point_text_note : suggest.member_point_text }}
                  </div>
                </div>
                <div class="td-scroll" v-else>
                  {{ key !== 5 ? suggest.comments[0].member_point_text : "" }}
                </div>
              </td>
              <template
                v-for="(comment, key2) of getCommentUnique(critSuggest)"
              >
                <td :key="key2 + comment.project_id" class="suggest">
                  <div class="td-scroll">
                    {{ key > 1 ? "" : getSuggestByPmId(critSuggest, comment.pm_id, suggest.criteria_id) }}
                  </div>
                </td>
              </template>
              <td class="suggest" :class="key === 5 ? 'text-left':''">
                <div class="td-scroll">
                  {{ key === 5 && suggest.dm_point_text && suggest.dm_point_text !== "Khác" ? '+ ' : '' }}
                  {{ suggest.dm_point_text }}
                </div>
              </td>
            </tr>
        </tbody>
      </table>
    </CheckPointCategory>
  </div>
</template>

<script>
import CheckPointCategory from "./CheckPointCategory.vue";
import CheckPointToolTip from "./CheckPointToolTip.vue";
import { checkpointMixin } from "@/mixins/checkpoint";

export default {
  name: "CheckPointResult",
  mixins: [checkpointMixin],
  components: {
    CheckPointCategory,
    CheckPointToolTip
  },
  created() {
    this.$root.$loading.start();
    let userCheckPointId = localStorage.getItem("user_code");
    this.$store
      .dispatch("checkpoint/getResultMember", {
        role: "MEMBER",
        user_checkpoint_list_id: userCheckPointId
      })
      .then(() => {
        this.$root.$loading.finish();
      })
      .catch(() => {
        this.$root.$loading.finish();
      });
  },
  methods: {
    convertCritSuggest(arr) {
      let critIds = arr.map(item => item.criteria_id);
      critIds = new Set(critIds);
      critIds = Array.from(critIds);

      let newCritsArr = [];

      for (let i = 0; i < critIds.length; i++) {
        let arrCrits = arr.filter(
          item => parseInt(item.criteria_id) === parseInt(critIds[i])
        );

        newCritsArr.push({
          criteria_name: arrCrits[0].criteria_name,
          criteria_id: arrCrits[0].criteria_id,
          member_point_text: arrCrits[0].member_point_text,
          member_point_text_note: arrCrits[0].member_point_text_note,
          dm_point_id: arrCrits[0].dm_point_id,
          dm_point_text: arrCrits[0].dm_point_text,
          pm_name: arrCrits[0].pm_name,
          project_id: arrCrits[0].project_id,
          comments: arrCrits
        });
      }
      return newCritsArr;
    },
  },
  computed: {
    critOpinion() {
      let arr = this.filterFormProp(0);
      return arr;
    },
    // I: Assessment by Attitude
    critAttitude() {
      let arr = this.filterFormProp(1);
      return arr;
    },
    opinions() {
      let arr = this.filterFormProp(1);
      let opinion = arr[arr.length - 1];
      return opinion;
    },
    // II: Assessment by Work => use in mixin checkpoint
    // critWork() {
    //   let arr = this.filterFormProp(2);
    //   return arr;
    // },
    // III: Assessment by Personal Skill
    // III
    critPersonal() {
      let arr = this.filterFormProp(3);
      return arr;
    },

    // unique item in critPersonal
    uniqueCritPersonal() {
      let critIds = this.critPersonal.map(item => item.criteria_id);
      critIds = new Set(critIds);
      critIds = Array.from(critIds);

      let data = [];
      critIds.map(item => {
        data.push(
          this.critPersonal.find(
            crit => parseInt(crit.criteria_id) === parseInt(item)
          )
        );
      });
      return data;
    },

    // IV: Your Suggest
    critSuggest() {
      let arr = this.filterFormProp(4);
      return arr;
    },
     uniqueCritOpinion() {
      let critIds = this.critSuggest.map(item => item.criteria_id);
      critIds = new Set(critIds);
      critIds = Array.from(critIds);

      let data = [];
      critIds.map(item => {
        data.push(
          this.critSuggest.find(
            crit => parseInt(crit.criteria_id) === parseInt(item)
          )
        );
      });
      return data;
    },

    // wish salary
    wishSalaries() {
      let strSalary = this.critSuggest[this.critSuggest.length - 1]
        .criteria_point;
      let arr = this.strPointToArray(strSalary).map(item => {
        return {
          id: item.id,
          value: "+ " + item.value
        };
      });
      return arr;
    },

    // convert criteriaWork to array projects for loop table_tr
    convertCritWork() {
      let arrProjects = [];
      let uniqueProjectId = this.critWork.map(item => item.project_id);
      uniqueProjectId = new Set(uniqueProjectId);
      uniqueProjectId = Array.from(uniqueProjectId);

      for (let i = 0; i < uniqueProjectId.length; i++) {
        let arrCrits = this.critWork.filter(
          item => parseInt(item.project_id) === parseInt(uniqueProjectId[i])
        );

        arrProjects.push({
          name: arrCrits[0].project_name,
          end_date: arrCrits[0].project_end,
          id: arrCrits[0].project_id,
          start_date: arrCrits[0].project_start,
          member_type: arrCrits[0].member_type,
          parent_criteria_id: arrCrits[0].parent_criteria_id,
          pm_name: arrCrits[0].pm_name,
          crits: arrCrits
        });
      }
      return arrProjects;
    },
      critSuggestAfter() {
      return this.convertCritSuggest(this.critSuggest);
    },
  }
};
</script>

<style lang="scss" scoped>
.cp-result {
  padding: 0 15px;

  & /deep/ .cp-tool {
    &__content {
      .scroll {
        max-height: 120px;
      }
    }
  }

  & /deep/ .category {
    .contents {
      &__item {
        padding: 12px 40px 15px;
        background-color: #fff;
        border-radius: 5px;

        &:not(:last-child) {
          margin-bottom: 5px;
        }

        b {
          margin-bottom: 5px;
          margin-left: -16px;
        }
        p {
          margin-bottom: 0;
        }

        div {
          white-space: pre-line;
          word-break: break-word;
        }
      }
    }

    &#attitude, &#work, &#personal {
      .td-scroll {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        overflow-y: auto;
        padding: 0.75rem;
      }
    }

    &#personal {
      .personal {
        &__content {
          max-width: 100%;
          overflow: auto;
        }
      }

      table {
        margin-bottom: 0;
        min-width: 2000px;
        width: unset;
        th {
          vertical-align: middle;
        }
        td {
          &:first-child {
            width: 90px;
          }

          &:nth-child(2) {
            width: 900px;
          }

          &._opinion {
            width: 175px;
          }
        }

        thead {
          tr {
            &:nth-child(2) {
              th {
                white-space: nowrap;
              }
            }
          }
        }
      }
    }

    &#work {
      table {
        margin-bottom: 0;
        p {
          text-align: center;
          margin-bottom: 0;
        }
        thead {
          tr {
            &:nth-child(2) {
              th {
                padding: 12px 6px;
                white-space: nowrap;
                &:nth-child(1) {
                  width: 50px;
                }
              }
            }
          }
        }

        tbody {
          td {
            text-align: center;

            &.name {
              width: 145px;
            }

            &:nth-child(3) {
              width: 110px;
            }

            &._index {
              width: 50px;
            }

            &._content {
              width: 450px;
            }
          }
        }
      }

      @media screen and (min-width: 1280px) and (max-width: 1440px) {
        overflow: auto;
        .category {
          &__title {
            min-width: 1320px;
          }
        }
        table {
          margin-bottom: 0;
          min-width: 1320px;
        }
      }
    }

    &#pm_opinion {
      table {
        .td-scroll {
          max-height: 300px;
          overflow-y: auto;
        }

        td {
          &:not(:nth-child(-n+2)) {
            width: 300px;
          }
        }
      }
    }
  }
}
</style>
